/*
   V 0.3.0 - 2024-10-02
     - Added reading $debug from vuex state. And refactored the
       setting of base url.

   V 0.2.0 - 2024-07-22
     - Added mainFunction for axios init

   V 0.1.1  - 2023-03-20
     - added: $staticBaseUrl

   V 0.1.0 -  2023-02-20
      - Added: import './registerServiceWorker';
      - MOdified Path

 */
/* eslint-disable indent */
/* eslint-disable import/no-extraneous-dependencies */

/**
 *  2023-03-15 commented this out as the fonts were not being loaded correctly on
 *  aws lambda, because of API gateway issues reading binary files. Therefor it is
 *  better to add this to the index.html
 */
// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

import axios from 'axios'

import Vue from 'vue'
import Vuex from 'vuex'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// import vuetify from './plugins/vuetify'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.min.css' // Add this line

import router from './main.router'
import vueSpinners from 'vue-spinners'

import googleMapsLoader from 'google-maps'
import Screenfull from 'screenfull'
// import * as _ from 'underscore'
// import moment from 'moment'
import * as Cookies2 from 'js-cookie'

// import vuetify from './plugins/vuetify'

import store from '@/plugins/store' // path to vuetify export import store from './store';
import App from './App.vue'
/**
 *  axios-cache-interceptor:
 *         In order to use axios-cache-interceptor make sure that the version of
 *         cache software is compatible with current version of axios.
 *
 */
import { setupCache } from 'axios-cache-interceptor'

import './registerServiceWorker'

import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

Vue.use(Vuetify)

Vue.use(Vuex)
Vue.use(vueSpinners)
//
// In gtag do not enable pageTrackerScreenviewEnabled as I think this caused problems with the
// router which was using #
//
Vue.use(VueGtag, {
  config: { id: 'G-8T6QTKLGEN' }, // Replace with your actual Google Analytics ID (e.g., 'G-XXXXXXXXXX')
  appName: 'Raptor Mobile' // Optional: Name of your app
}, router) // Pass the router instance for automatic page tracking

Vue.prototype.$version = '1.2.2'
Vue.prototype.$copyRightNotice = ''
Vue.prototype.$year = '2026'
Vue.prototype.$company = 'Raptor Vehicle Tracking'

Vue.prototype.$loggedIn = false
// ----------------------------------------------------------------------
// $debug is set based on: `process.env.NODE_ENV === 'production'
// and not here in Vue.prototype.$debug = false
// ----------------------------------------------------------------------
// Vue.prototype.$debug = false
Vue.prototype.$mock = false

Vue.prototype.$applicationName = 'Raptor'
Vue.prototype.$loggedIn = false

Vue.prototype.$login_url = '/api/authenticate'

if (Vue.prototype.$debug) {
  console.log(` main.js - debug: ${Vue.prototype.$debug}`)
}

Object.defineProperty(Vue.prototype, '$cookies', { value: Cookies2 })

const opts = {
  icons: {
    iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
}

// ----------------------------------------------------------------------------------
//  2022-09-20
//  Below is necessary as when the page is refreshed or reloaded we need to reload
//  the token into the axios header
// ----------------------------------------------------------------------------------
axios.defaults.headers.common.Authorization = `Bearer ${store.state.token}` // <<----

///
///  2023-03-20 -
///     Added so that images could be referenced without the need to base64 encode then
///     so they fit through the AWS API gateway.
///
Vue.prototype.$staticBaseUrl =
  'https://rap-con-assets.s3.af-south-1.amazonaws.com/mobile'

/*
 *  NB paths must NOT be postfixed with forward slash '/' as this does not work
 *
 */
Vue.prototype.$baseUrl = 'https://localhost:44310/Prod'
// Vue.prototype.$baseUrl = 'https://192.168.0.164:44310/Prod'
// Vue.prototype.$baseUrl = 'http://192.168.0.164:8081/Prod'
// Vue.prototype.$baseUrl = "/Prod";
// -------------------------------------------------------------------
//
// 2023-02-20
//
//   In the serverless environment all api calls must be directed to
//   Prod/api but in development for some reason the api call do not
//   take on the root configure in launchSettings.json namely
//    "launchUrl": "Prod",
//   theres tof the app does but API calls not, not sure why
//
// -------------------------------------------------------------------
console.log(' Root Path: ')
if (process.env.NODE_ENV === 'production') {
    ///  2023-03-17
    ///     - This was /Prod as the was being picked up and
    ///       all API calls need to go through this.
    ///
    Vue.prototype.$baseUrl = ''
}

Vue.prototype.$debug = store.state.debug

console.log(`$baseUrl:${Vue.prototype.$baseUrl}`)
console.log(`$debug:${Vue.prototype.$debug}`)

// ---------------------------------------------------------------
// Initialise the caching
// ---------------------------------------------------------------
Vue.prototype.$mainFunction = function () {
  var instance = axios.create()
  var axiosCache = setupCache(instance)
  Vue.prototype.$axiosCache = axiosCache
}

Vue.prototype.$mainFunction()

Vue.prototype.$axios = axios

// Object.defineProperty(Vue.prototype, '$axios', { value: axios })
// Object.defineProperty(Vue.prototype, '$moment', { value: moment })
// Object.defineProperty(Vue.prototype, '$_', { value: _ })
Object.defineProperty(Vue.prototype, '$googleMapsLoader', {
  value: googleMapsLoader
})

Object.defineProperty(Vue.prototype, '$screenfull', { value: Screenfull })

new Vue({
  store,
  router,
  vuetify: new Vuetify(opts),

  render: (h) => h(App)
}).$mount('#app')
